const Button = ({ children, onClick, className = "" }) => {
  const hasCustomBg = className.includes("!bg");

  return (
    <button
      onClick={onClick}
      className={`${
        !hasCustomBg ? "bg-gradient-to-r from-[#448636] to-[#E2AE5C] text-white" : ""
      } px-4 py-2 rounded-md font-semibold shadow-md hover:opacity-90 transition ${className}`}
    >
      {children}
    </button>
  );
};
export default Button;